import { render } from "./EventDetail.vue?vue&type=template&id=6f04f940&scoped=true&ts=true"
import script from "./EventDetail.vue?vue&type=script&lang=ts"
export * from "./EventDetail.vue?vue&type=script&lang=ts"

import "./EventDetail.vue?vue&type=style&index=0&id=6f04f940&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f04f940"]])

export default __exports__